import * as Utils from "Assets/Utils";

import ClientHttpRequest from "Api/ClientHttpRequest";
import Immutable from "immutable";
import { createModal } from "Modules/Modal";
import { isLoading } from "Modules/Loading";
import { post } from "axios";

const initialState = Immutable.Map({})
  .set("Search", new Immutable.List([]))
  .set("Response", new Immutable.Map({}))
  .set("Get", new Immutable.Map({}));

/* Types */
export const GET_DOCUMENTS = "GET_DOCUMENTS";
export const SAVE_FILE = "SAVE_FILE";
export const GET_URL_DOCUMENTS = "GET_URL_DOCUMENTS";

/* Reducer */
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_DOCUMENTS:
      return state.set("Get", new Immutable.Map(action.Obj));
    case SAVE_FILE:
      return state.set("Response", new Immutable.Map(action.Obj));
    case GET_URL_DOCUMENTS:
      return state.set("Search", new Immutable.Map(action.Obj));
    default:
      return state;
  }
};

/* Action Creators */

export const getDocuments = form => {
  return dispatch => {
    dispatch(isLoading(true));
    let data = Utils.ec_(form)

    return new ClientHttpRequest({
      service: "api/getDocuments",
      method: "POST",
      data: {reference: data},
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        uid: sessionStorage.uid,
        "n": localStorage.n
      })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false));
        response.data = Utils.ds_(response.data.reference);
        response.data.UID = Utils.getUUID();
        dispatch({ type: GET_DOCUMENTS, Obj: response.data });
      })
      .catch(error => {
        dispatch(isLoading(false));
        dispatch(
          createModal(
            Utils.errorMessage(Utils.getMessageResponse(error.response.data))
          )
        );
        throw error;
      });
  };
};

export const getIdDocuments = form => {
  return dispatch => {
    dispatch(isLoading(true));
    let data = Utils.ec_(form)

    return new ClientHttpRequest({
      service: "api/getIdDocuments",
      method: "POST",
      data: {reference: data},
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        uid: sessionStorage.uid,
        "n": localStorage.n
      })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false));
        response.data = Utils.ds_(response.data.reference)
        return response.data;
      })
      .catch(error => {
        dispatch(isLoading(false));
        dispatch(
          createModal(
            Utils.errorMessage(Utils.getMessageResponse(error.response.data))
          )
        );
        throw error;
      });
  };
};

export const uploadDocument = form => {
  const headers = {
    "Content-Type": "multipart/form-data",
    Authorization: sessionStorage.access_token,
    uid: sessionStorage.uid
  };

  if (localStorage.type == 'Donataria') {
    headers.idDonataria = localStorage.idDonataria || ''
  }

  return dispatch => {
    dispatch(isLoading(true));

    return post("/api/uploadDocument", form, { headers })
      .then(response => {
        dispatch(isLoading(false));
        dispatch({ type: SAVE_FILE, Obj: response.data });
        return response.data;
      })
      .catch(error => {
        dispatch(isLoading(false));
        dispatch(
          createModal(
            Utils.errorMessage(Utils.getMessageResponse(error.response.data))
          )
        );
        throw error;
      });
  };
};

export const getURLDocuments = form => {
  return dispatch => {
    dispatch(isLoading(true));
    let data = Utils.ec_(form)
    return new ClientHttpRequest({
      service: "api/getURLDocuments",
      method: "POST",
      data: {reference: data},
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        uid: sessionStorage.uid,
        "n": localStorage.n
      })
    })
      .request()
      .then(response => {
        response.data = Utils.ds_(response.data.reference)
        dispatch(isLoading(false));
        dispatch({ type: GET_URL_DOCUMENTS, Obj: response.data });
      })
      .catch(error => {
        dispatch(isLoading(false));
        dispatch(
          createModal(
            Utils.errorMessage(Utils.getMessageResponse(error.response.data))
          )
        );
        throw error;
      });
  };
};

export const deleteDocument = form => {
  return dispatch => {
    dispatch(isLoading(true));

    return new ClientHttpRequest({
      service: "api/deleteDocument",
      method: "POST",
      data: { ...form },
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        uid: sessionStorage.uid
      })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false));
        return response.data;
      })
      .catch(error => {
        dispatch(isLoading(false));
        dispatch(
          createModal(
            Utils.errorMessage(Utils.getMessageResponse(error.response.data))
          )
        );
        throw error;
      });
  };
};


export const getDonatariasByCSV = form => {
  const headers = {
    "Content-Type": "multipart/form-data",
    Authorization: sessionStorage.access_token,
    uid: sessionStorage.uid
  };

  if (localStorage.type == 'Donataria') {
		headers.idDonataria = localStorage.idDonataria || ''
	}

  return dispatch => {
    dispatch(isLoading(true));

    return post("/api/getDonatariasByCSV", form, { headers })
      .then(response => {
        dispatch(isLoading(false))
        return response.data
      })
      .catch(error => {
        dispatch(isLoading(false));
        dispatch(
          createModal(
            Utils.errorMessage(Utils.getMessageResponse(error.response.data))
          )
        );
        throw error;
      });
  };
};

export const getMontosDonativoPreByCSV = form => {
  const headers = {
    "Content-Type": "multipart/form-data",
    Authorization: sessionStorage.access_token,
    uid: sessionStorage.uid
  };

  if (localStorage.type == 'Donataria') {
		headers.idDonataria = localStorage.idDonataria || ''
	}

  return dispatch => {
    dispatch(isLoading(true));

    return post("/api/getMontosDonativoPreByCSV", form, { headers })
      .then(response => {
        dispatch(isLoading(false))
        return response.data
      })
      .catch(error => {
        dispatch(isLoading(false));
        dispatch(
          createModal(
            Utils.errorMessage(Utils.getMessageResponse(error.response.data))
          )
        );
        throw error;
      });
  };
};

export const exportListDonatariaCSV = (form) => {
  
  let temp={
    donatarias: form
  }
	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/exportListDonatariaCSV',
			method: "POST",
      data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid }),
			responseType: 'arraybuffer'
		}).request().then(response => {
			dispatch(isLoading(false))
      // const uint8Array = new Uint8Array(response.data);
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileName = 'Lista-Donataria.xlsx';
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
	   

		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}


// WEBPACK FOOTER //
// ./src/modules/Grantees/Information/Documents.js